import React from "react";
import "./About.css";
import Jump from "react-reveal/Jump";
import assets from "../../assets/my_pic.jpg"
const About = () => {
  return (
    <>
      <Jump>
        <div className="about" id="about">
          <div className="row">
            <div className="col-md-6 col-xl-6 col-lg-6 col-xs-12 about-img">
              <img
                src={assets}
                alt="profile_pic"
              />
            </div>
            <div className="col-md-6 col-xl-6 col-lg-6 col-xs-12 about-content">
              <h1>About me</h1>
              <p>
                Passionate, detail-oriented full-stack web developer with hands-on experience designing interactive, user-centric applications. Skilled in managing both frontend and backend development to create efficient, scalable, and smooth digital solutions. Eager to learn, innovate, and contribute to impactful projects that solve real-world problems and enhance user experiences across platforms.
              </p>
            </div>
          </div>
        </div>
      </Jump>
    </>
  );
};

export default About;
